var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader",class:{
    'is-relative': _vm.relative,
    'is-inline': _vm.inline,
    'has-minheight': _vm.minHeight
  }},[_c('img',{attrs:{"src":require("@/assets/images/loader.gif")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }